import { createCachedFetch } from '@/shared/lib/cache';
import { fetchLegalRegionById, type LegalRegionView } from './legal-region.api';

const getLegalRegionById = createCachedFetch(fetchLegalRegionById, 'legal-region', {
  permanent: true,
});

/**
 * 여러 법정 지역을 병렬로 조회 (영구 캐시 적용)
 */
export async function getLegalRegionsByIds(
  legalRegionIds: string[]
): Promise<Map<string, LegalRegionView | null>> {
  const uniqueIds = Array.from(new Set(legalRegionIds.filter(Boolean)));
  if (uniqueIds.length === 0) return new Map();

  const results = await Promise.all(
    uniqueIds.map(async (id) => {
      const data = await getLegalRegionById(id);
      return [id, data] as const;
    })
  );
  return new Map(results);
}

export { getLegalRegionById, type LegalRegionView };
